import styled, { css } from 'styled-components';
import { mobileMax } from '../../constants';

export const SCPactometroCheck = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-family: 'Roboto';
  margin: 0 -5px;
  .item-partido {
    padding: 5px;
    width: 100%;
  }
  .row-pactometro {
    padding: 5px;
    box-sizing: border-box;
    width: 50%;
    @media screen and (min-width: 480px) {
      width: 33.333%;
    }
    @media screen and (min-width: 764px) {
      width: 25%;
    }
    ${props =>
      props.cols !== undefined
        ? css`
            width: ${100 / (props.cols || 2)}%;
          `
        : ''};

    input[type='checkbox'] {
      position: absolute;
      left: -999em;
    }
    label {
      cursor: pointer;
      display: block;
      font-size: 13px;
      margin-bottom: 0;
      min-height: 31px;
      overflow: hidden;
      padding: 3px 40px 1px 5px;
      position: relative;
      text-align: left;
      background: #f7f7f7;
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: block;
        line-height: 1.1;
      }
      p {
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: #6c6c6c;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
        padding-top: 0;
      }
      &::after {
        background: #aaa;
        bottom: 0;
        content: '';
        display: block;
        width: 23px;
        height: 23px;
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 2;
      }
      &:hover {
        &::after {
          background: #b9b9b9;
        }
      }
    }
    &::before {
      content: '';
      height: 7px;
      left: 0;
      position: absolute;
      top: 0;
      width: 5px;
      z-index: 1;
    }
    input[type='checkbox'] {
      &:checked {
        & ~ label {
          &::after {
            background: #007201 url(${props => props.labelCheckImage}) no-repeat
              50% 50%;
          }
        }
      }
    }
  }
`;

export const SCContainerPactometroSimple = styled.div`
  width: auto;
  padding: 0;
  ${props =>
    props.cols === 1
      ? css`
          display: block;
        `
      : css`
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          > * {
            width: 50%;
          }
        `};
  @media screen and (max-width: ${mobileMax}) {
    display: block;
    > * {
      width: 100%;
    }
  }
  .tabsContent & {
    margin: 0 -10px;
  }

  .content-pactos-barrasSimple {
    .bloque-pactometro {
      @media screen and (min-width: 580px) {
        width: 100%;
        margin: 5px 0px 5px;
      }
    }
  }
  .content-pactosSimple {
    .pactos {
      .row-pactometro {
        @media screen and (min-width: 768px) {
          width: 33.333%;
        }
        @media screen and (min-width: 980px) {
          width: 50%;
        }
      }
    }
    label {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;
